
import { Placement } from '@post-office/placements-frontend/statuspage-actions-spotlight-placement';
export default Placement;
